// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__182js","buttons":"styles_buttons__1ZpgR"};